import { render, staticRenderFns } from "./index.vue?vue&type=template&id=016f86e1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=016f86e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f86e1",
  null
  
)

export default component.exports